<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2" v-if="loading">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-if="!loading">
              <b-sidebar
                id="sidebar-right"
                title="Sidebar"
                :backdrop-variant="'dark'"
                bg-variant="white"
                backdrop
                right
                shadow
                no-header
                ref="mySidebar"
                style="min-width: 400px"
              >
                <template #default="{ hide }">
                  <div class="p-3">
                    <h4
                      id="sidebar-no-header-title"
                      class="d-flex align-items-center justify-content-between"
                    >
                      Crystal Profile
                      <button
                        type="button"
                        class="btn-close"
                        @click="hide"
                      ></button>
                    </h4>
                    <!-- <div
                      v-if="
                        crystalProfile ||
                        (detail.linkedin_url &&
                          detail.linkedin_url !== '' &&
                          !isNotReady &&
                          !fetchingProfile)
                      "
                    >
                      <div class="card card-plain text-center mt-5">
                        <a href="javascript:;">
                          <img
                            class="avatar avatar-xl shadow"
                            src="https://media-exp1.licdn.com/dms/image/C4D03AQGC8zyYw6LsKg/profile-displayphoto-shrink_400_400/0/1643280678663?e=1668038400&v=beta&t=ufa3NTC_60wnxgmLsnqoUGUW1b1xsBqJMwQRLvDjEP4"
                          />
                        </a>
                        <div class="card-body px-0">
                          <h4 class="card-title">Stefangeorg</h4>
                          <h6 class="category text-info text-gradient">
                            Loan Counselor
                          </h6>
                          <p class="card-description">
                            "Don't walk behind me; I may not lead. Don't walk in
                            front of me; I may not follow. Just walk beside me
                            and be my friend."
                          </p>

                          <b-badge
                            variant="info bg-gradient-primary"
                            style="text-transform: uppercase"
                            >STEADFAST</b-badge
                          >
                          <b-badge
                            variant="info bg-gradient-primary"
                            style="text-transform: uppercase"
                            >methodical</b-badge
                          >
                          <b-badge
                            variant="info bg-gradient-primary"
                            style="text-transform: uppercase"
                            >efficient</b-badge
                          >
                          <div class="clearfix"></div>
                          <button
                            type="button"
                            class="
                              btn btn-facebook btn-simple btn-lg
                              mb-0
                              pe-3
                              ps-2
                            "
                          >
                            <i class="fab fa-facebook" aria-hidden="true"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-twitter btn-simple btn-lg mb-0 px-2"
                          >
                            <i class="fab fa-twitter" aria-hidden="true"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-github btn-simple btn-lg mb-0 px-2"
                          >
                            <i class="fab fa-github" aria-hidden="true"></i>
                          </button>
                          <div class="clearfix"></div>
                          <ul class="list-group mt-3">
                            <li class="list-group-item text-primary text-start">
                              <i class="fa fa-bars mr-4"></i> Cras justo odio
                            </li>
                            <li class="list-group-item text-primary text-start">
                              <i class="fa fa-sitemap mr-4"></i> Dapibus ac
                              facilisis in
                            </li>
                            <li class="list-group-item text-primary text-start">
                              <i class="fa fa-cloud mr-4"></i> Morbi leo risus
                            </li>
                            <li class="list-group-item text-primary text-start">
                              <i class="fa fa-file mr-4"></i> Porta ac
                              consectetur ac
                            </li>
                            <li class="list-group-item text-primary text-start">
                              <i class="fa fa-phone mr-4"></i> Vestibulum at
                              eros
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div> -->
                    <div
                      class="text-center text-primary my-5 py-5"
                      v-if="fetchingProfile"
                    >
                      <b-spinner class="align-middle mr-2"></b-spinner>
                      <strong>Fetching Profile...</strong>
                    </div>
                    <div
                      v-if="!crystalProfile"
                    >
                      <form
                        v-if="!fetchingProfile"
                        @submit.prevent="onSubmitLinkedin"
                        novalidate
                        enctype="multipart/form-data"
                        :class="
                          submitted
                            ? 'needs-validation was-validated'
                            : 'needs-validation'
                        "
                      >
                        A Crystal Profile Has Not Been Generated for This
                        Contact.

                        <label for="linkedin_url"
                          >Please enter your LinkedIn URL:</label
                        >
                        <input
                          type="text"
                          name="linkedin_url"
                          id="linkedin_url"
                          v-model.trim="$v.linkedin_url.$model"
                          class="form-control"
                          required
                        />
                        <div
                          v-if="
                            submitted &&
                            (!$v.linkedin_url.url || !$v.linkedin_url.required)
                          "
                          class="invalid-tooltip"
                        >
                          You should provide a valid url.
                        </div>
                        <p></p>
                        <p></p>
                        <b-button
                          type="submit"
                          class="btn btn-primary waves-effect waves-light"
                        >
                          Fetch Crystal Profile</b-button
                        >
                      </form>
                    </div>
                    <p></p>
                  </div>
                </template>
              </b-sidebar>
              <!-- Start Title -->
              <div class="d-flex bd-highlight mb-3">
                <div class="me-auto p-2 bd-highlight">
                  <h4 class="card-title">
                    {{
                      detail.last_name +
                      ", " +
                      detail.first_name +
                      " " +
                      detail.middle_name
                    }}
                  </h4>
                  <!-- Card Title -->
                </div>

                <div class="p-2 bd-highlight">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect waves-light"
                    @click="
                      $router.push(
                        '/mpg/contacts/' + detail.contact_id + '/edit'
                      )
                    "
                  >
                    Edit
                  </button>
                </div>

                <div class="p-2 bd-highlight">
                  <b-button
                    class="btn btn-danger waves-effect waves-light"
                    v-b-modal.delete_contact_modal
                  >
                    Delete</b-button
                  >
                </div>
                <div class="p-2 bd-highlight">
                  <b-button
                    v-if="!crystalFile"
                    class="btn btn-info waves-effect waves-light"
                    v-b-toggle.sidebar-right
                  >
                    Crystal Profile</b-button
                  >
                  <a
                    target="_blank"
                    :href="crystalFile.file"
                    v-if="crystalFile"
                    class="btn btn-info waves-effect waves-light"
                  >
                    Crystal Profile</a
                  >
                </div>
              </div>
              <!-- End Title -->

              <!-- Start Modal -->
              <b-modal
                id="delete_contact_modal"
                tabindex="-1"
                aria-labelledby="delete_modal_label"
                aria-hidden="true"
                hide-footer
              >
                <template #modal-header>
                  <h6 class="text-center">
                    DELETE {{ detail.person_title }},
                    {{ detail.first_name }}
                  </h6>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    :disabled="loadingAction"
                    @click="$bvModal.hide('delete_contact_modal')"
                  ></button>
                </template>

                <div class="modal-body">
                  <h3 class="text-center">Are you sure?</h3>
                  <h6 class="text-center">You won't be able to revert this.</h6>
                  <div class="d-grid gap-2 d-md-block text-center">
                    <form method="POST">
                      <input
                        type="hidden"
                        name="csrfmiddlewaretoken"
                        value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                      />
                      <button
                        class="btn btn-danger waves-effect waves-light"
                        type="submit"
                        value="11"
                        @click="deleteContact(detail.contact_id)"
                        :disabled="loadingAction"
                      >
                        Delete
                      </button>
                      <button
                        class="btn btn-light waves-effect waves-light"
                        type="button"
                        :disabled="loadingAction"
                        data-bs-dismiss="modal"
                        @click="$bvModal.hide('delete_contact_modal')"
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                </div>
              </b-modal>
              <!-- End Modal -->

              <b-modal
                id="add_schedule_event_modal"
                tabindex="-1"
                aria-labelledby="add_schedule_event_modal"
                aria-hidden="true"
                hide-footer
              >
                <template #modal-header>
                  <h6 class="text-center">TASK OR MEETING</h6>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    :disabled="loadingAction"
                    @click="$bvModal.hide('add_schedule_event_modal')"
                  ></button>
                </template>

                <div class="modal-body">
                  <div class="d-grid gap-2 d-md-block text-center">
                    <form method="POST">
                      <input
                        type="hidden"
                        name="csrfmiddlewaretoken"
                        value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                      />
                      <button
                        class="btn btn-success waves-effect waves-light mr-3"
                        type="button"
                        value="11"
                        @click="
                          $bvModal.hide('add_schedule_event_modal');
                          $bvModal.show('add_task_modal');
                        "
                      >
                        Task
                      </button>
                      <button
                        class="btn btn-success waves-effect waves-light ml-3"
                        type="button"
                        data-bs-dismiss="modal"
                        @click="$bvModal.show('add_schedule_modal')"
                      >
                        Meeting
                      </button>
                    </form>
                  </div>
                </div>
              </b-modal>

              <div class="row">
                <div class="col-lg-12">
                  <b-tabs
                    v-model="tabIndex"
                    class="nav-tabs-custom nav-justified"
                    active-tab-class="p-3"
                    @activate-tab="onChangeTab"
                  >
                    <b-tab>
                      <template #title> Details </template>
                      <b-card-title></b-card-title>
                      <b-card-text>
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="card h-100">
                              <div class="card-body">
                                <!-- <h4 class="card-title">Details</h4> -->
                                <!-- Card Title -->
                                <!-- <p></p> -->

                                <!-- Start Table -->
                                <div class="table-responsive mb-0">
                                  <table
                                    class="
                                      table
                                      align-middle
                                      table-striped table-nowrap
                                      mb-0
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td>Name</td>
                                        <td>
                                          <span
                                            style="text-transform: uppercase"
                                          >
                                            {{ detail.title }}
                                            {{
                                              detail.last_name +
                                              ", " +
                                              detail.first_name +
                                              " " +
                                              detail.middle_name
                                            }}</span
                                          >
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Current Companies</td>
                                        <td style="white-space: normal">
                                          <span
                                            v-for="(
                                              org, i
                                            ) in detail.organizations_contacts.filter(
                                              (e) =>
                                                e.employment_status === 'active'
                                            )"
                                            :key="i"
                                            style="text-transform: uppercase"
                                          >
                                            {{ org.organization.name }}
                                            <template
                                              v-if="
                                                i + 1 <
                                                detail.organizations_contacts.filter(
                                                  (e) =>
                                                    e.employment_status ===
                                                    'active'
                                                ).length
                                              "
                                            >
                                              , {{ " " }}
                                            </template>
                                          </span>
                                        </td>
                                      </tr>
                                      <!-- <tr>
                                        <td>Title</td>
                                        <td>
                                          <span
                                            style="text-transform: uppercase"
                                          >
                                            {{
                                              detail.organizations_contacts.find(
                                                (e) =>
                                                  e.employment_status ===
                                                  "active"
                                              )
                                                ? detail.organizations_contacts.find(
                                                    (e) =>
                                                      e.employment_status ===
                                                      "active"
                                                  ).job_title
                                                : ""
                                            }}
                                          </span>
                                        </td>
                                      </tr> -->

                                      <tr>
                                        <td>Gender</td>

                                        <td class="text-capitalize">
                                          {{ detail.gender }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Personal Email</td>

                                        <td class="text-capitalize">
                                          {{ detail.personal_email }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Personal Mobile</td>

                                        <td class="text-capitalize">
                                          {{ detail.personal_mobile }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Date of Birth</td>

                                        <td class="text-capitalize">
                                          {{
                                            detail.date_of_birth
                                              ? moment(
                                                  detail.date_of_birth
                                                ).format("MM/DD/YYYY")
                                              : ""
                                          }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Personal Address</td>

                                        <td
                                          class="text-capitalize"
                                          style="white-space: normal"
                                        >
                                          {{ detail.personal_address }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Linkedin URL</td>

                                        <td class="text-capitalize">
                                          {{ detail.linkedin_url }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- End Table -->
                              </div>
                              <!-- End Card Body -->
                            </div>
                            <!-- End Card -->
                          </div>
                          <div class="col-lg-6 position-relative">
                            <FullCalendar
                              ref="fullCalendar"
                              :options="calendarOptions"
                            />
                            <div
                              class="
                                text-center text-primary
                                my-2
                                loading-indicator
                              "
                              v-if="loadingCalendar"
                            >
                              <b-spinner class="align-middle mr-2"></b-spinner>
                            </div>
                            <p></p>
                            <div class="row">
                              <div class="col-12 text-end">
                                <b-button
                                  class="
                                    btn btn-success
                                    waves-effect waves-light
                                  "
                                  @click="
                                    $bvModal.show('add_schedule_event_modal')
                                  "
                                >
                                  Create</b-button
                                >
                              </div>
                            </div>
                          </div>
                          <p></p>
                          <p></p>
                          <div class="col-lg-12">
                            <div class="card">
                              <div class="card-header pb-0 px-3">
                                <h4 class="mb-0 card-title">Notes</h4>
                              </div>
                              <div class="card-body pt-4 p-3">
                                <div v-if="!listNotes">Getting notes...</div>
                                <ul v-if="listNotes" class="list-group">
                                  <li
                                    v-for="(note, i) in listNotes"
                                    :key="i"
                                    class="
                                      list-group-item
                                      border-0
                                      d-flex
                                      p-4
                                      mb-2
                                      bg-gray-100
                                      border-radius-lg
                                    "
                                  >
                                    <div class="d-flex flex-column">
                                      <b-modal
                                        :id="'delete_node_modal' + note.id"
                                        tabindex="-1"
                                        aria-labelledby="delete_node_modal"
                                        aria-hidden="true"
                                        hide-footer
                                      >
                                        <template #modal-header>
                                          <h6 class="text-center">
                                            DELETE THIS NOTE
                                          </h6>
                                          <button
                                            type="button"
                                            class="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            :disabled="loadingAction"
                                            @click="
                                              $bvModal.hide(
                                                'delete_node_modal' + note.id
                                              )
                                            "
                                          ></button>
                                        </template>

                                        <div class="modal-body">
                                          <h3 class="text-center">
                                            Are you sure?
                                          </h3>
                                          <h6 class="text-center">
                                            You won't be able to revert this.
                                          </h6>
                                          <div
                                            class="
                                              d-grid
                                              gap-2
                                              d-md-block
                                              text-center
                                            "
                                          >
                                            <form method="POST">
                                              <input
                                                type="hidden"
                                                name="csrfmiddlewaretoken"
                                                value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                                              />
                                              <button
                                                class="
                                                  btn btn-danger
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                value="11"
                                                @click="deleteNote(note.id)"
                                                :disabled="loadingAction"
                                              >
                                                Delete
                                              </button>
                                              <button
                                                class="
                                                  btn btn-light
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                :disabled="loadingAction"
                                                data-bs-dismiss="modal"
                                                @click="
                                                  $bvModal.hide(
                                                    'delete_node_modal' +
                                                      note.id
                                                  )
                                                "
                                              >
                                                Cancel
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :id="'delete_edit_modal' + note.id"
                                        tabindex="-1"
                                        aria-labelledby="delete_edit_modal"
                                        aria-hidden="true"
                                        hide-footer
                                      >
                                        <template #modal-header>
                                          <h6 class="text-center">EDIT NOTE</h6>
                                          <button
                                            type="button"
                                            class="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            :disabled="loadingAction"
                                            @click="
                                              $bvModal.hide(
                                                'delete_edit_modal' + note.id
                                              )
                                            "
                                          ></button>
                                        </template>

                                        <div class="modal-body">
                                          <div
                                            class="
                                              d-grid
                                              gap-2
                                              d-md-block
                                              text-center
                                            "
                                          >
                                            <form method="POST">
                                              <input
                                                type="hidden"
                                                name="csrfmiddlewaretoken"
                                                value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                                              />
                                              <VueEditor
                                                v-model="note.description"
                                              />
                                              <p></p>
                                              <p></p>
                                              <button
                                                class="
                                                  btn btn-danger
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                value="11"
                                                @click="editNote(note)"
                                                :disabled="loadingAction"
                                              >
                                                Save
                                              </button>
                                              <button
                                                class="
                                                  btn btn-light
                                                  waves-effect waves-light
                                                "
                                                type="button"
                                                :disabled="loadingAction"
                                                data-bs-dismiss="modal"
                                                @click="
                                                  $bvModal.hide(
                                                    'delete_edit_modal' +
                                                      note.id
                                                  )
                                                "
                                              >
                                                Cancel
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <h6 class="mb-3 text-sm">
                                        {{
                                          note.created_by
                                            ? note.created_by.username
                                            : ""
                                        }}
                                      </h6>
                                      <span
                                        class="mb-2 text-xs"
                                        v-html="note.description"
                                      ></span>
                                    </div>
                                    <div class="ms-auto text-end">
                                      <a
                                        class="
                                          btn btn-link
                                          text-danger text-gradient
                                          px-3
                                          mb-0
                                        "
                                        href="javascript:;"
                                        @click="
                                          $bvModal.show(
                                            'delete_node_modal' + note.id
                                          )
                                        "
                                        ><i
                                          class="far fa-trash-alt me-2"
                                          aria-hidden="true"
                                        ></i
                                        >Delete</a
                                      >
                                      <a
                                        class="btn btn-link text-dark px-3 mb-0"
                                        href="javascript:;"
                                        @click="
                                          $bvModal.show(
                                            'delete_edit_modal' + note.id
                                          )
                                        "
                                        ><i
                                          class="
                                            fas
                                            fa-pencil-alt
                                            text-dark
                                            me-2
                                          "
                                          aria-hidden="true"
                                        ></i
                                        >Edit</a
                                      >
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <p></p>
                          <div class="col-lg-12">
                            <VueEditor v-model="noteContent" />
                          </div>
                          <div class="col-12 text-end">
                            <button
                              type="button"
                              class="
                                btn btn-primary
                                mt-3
                                waves-effect waves-light
                              "
                              :disabled="loadingAction"
                              @click="onAddNote"
                            >
                              Add Note
                            </button>
                          </div>
                          <p></p>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-organizations"></i
                        ></span>
                        <span class="badge rounded-pill bg-danger float-end">{{
                          detail.organizations_contacts.filter((x) => {
                            return x.employment_status !== "active";
                          }).length
                        }}</span>

                        <span
                          class="badge rounded-pill bg-success float-end me-2"
                          >{{
                            detail.organizations_contacts.filter((x) => {
                              return x.employment_status === "active";
                            }).length
                          }}</span
                        >
                        <span class="d-none d-sm-block">Organizations</span>
                      </template>
                      <b-card-text>
                        <div class="d-flex justify-content-end">
                          <router-link
                            :to="
                              '/mpg/contacts/' +
                              detail.contact_id +
                              '/organization/add'
                            "
                            class="btn btn-primary waves-effect waves-light"
                          >
                            Add Organization
                          </router-link>
                        </div>

                        <p></p>

                        <div class="card">
                          <div class="card-body">
                            <!-- Start Filter -->
                            <div class="row">
                              <div
                                class="
                                  d-flex
                                  flex-row-reverse
                                  justify-content-between
                                "
                              >
                                <div>
                                  <b-dropdown
                                    id="dropdown-1"
                                    variant="link"
                                    toggle-class="text-reset pt-0"
                                  >
                                    <template #button-content>
                                      <span class="text-muted"
                                        >Property Status:</span
                                      >
                                      <span class="fw-semibold text-capitalize"
                                        >{{ filterStatus
                                        }}<i
                                          class="mdi mdi-chevron-down ms-1"
                                        ></i
                                      ></span>
                                    </template>
                                    <b-dropdown-item
                                      @click="filterStatus = 'active'"
                                      >Active</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="filterStatus = 'expired'"
                                      >Expired</b-dropdown-item
                                    >
                                  </b-dropdown>
                                </div>
                                <h4 class="card-title mb-4">
                                  Organizations List
                                </h4>
                              </div>
                            </div>
                            <!-- End Filter -->

                            <div class="row g-1" style="overflow: auto">
                              <div class="table-responsive mb-0">
                                <table
                                  class="
                                    table table-hover table-borderless
                                    align-middle
                                    table-centered table-nowrap
                                    mt-1
                                    mb-0
                                    ctrl-h
                                  "
                                  style="overflow: visible"
                                >
                                  <thead class="table-light">
                                    <tr>
                                      <th></th>
                                      <th>Name</th>
                                      <th>Job Title</th>
                                      <th>Work Email</th>
                                      <th>Work Mobile Phone</th>
                                      <th>Work Office Phone</th>
                                      <th>ICE Handle</th>
                                      <th>Teams Handle</th>
                                      <th>Salutation</th>
                                      <th>Department</th>
                                      <th>Preferred Checkin Frequency</th>
                                      <th>Preferred Time Day Calls</th>
                                      <th>Preferred Time Day Emails</th>
                                      <th>Preferred Time Week Day Calls</th>
                                      <th>Prederred Time Week Day Emails</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      v-for="(org, index) in filteredOrg"
                                      :key="index"
                                    >
                                      <td class="text-center">
                                        <router-link
                                          :to="
                                            '/mpg/contacts/' +
                                            detail.contact_id +
                                            '/organization/' +
                                            org.organization.organization_id +
                                            '/edit'
                                          "
                                          class="
                                            btn btn-link
                                            text-primary
                                            mb-0
                                            p-0
                                          "
                                        >
                                          <i class="fas fa-edit text-xs"></i>
                                        </router-link>
                                      </td>
                                      <td>
                                        <router-link
                                          :to="
                                            '/mpg/organizations/' +
                                            org.organization.organization_id +
                                            '/details'
                                          "
                                          >{{
                                            org.organization.name
                                          }}</router-link
                                        >
                                      </td>
                                      <td>{{ org.job_title }}</td>
                                      <td>{{ org.work_email }}</td>
                                      <td>{{ org.work_mobile }}</td>
                                      <td>{{ org.work_office_phone }}</td>
                                      <td>{{ org.ice_handle }}</td>
                                      <td>{{ org.teams_handle }}</td>
                                      <td>{{ org.salutation }}</td>
                                      <td>{{ org.department }}</td>
                                      <td>
                                        {{ org.prefered_checkin_frequency }}
                                      </td>
                                      <td>{{ org.prefered_time_day_calls }}</td>
                                      <td>
                                        {{ org.prefered_time_day_emails }}
                                      </td>
                                      <td>
                                        {{ org.prefered_time_week_day_calls }}
                                      </td>
                                      <td>
                                        {{ org.prefered_time_week_day_emails }}
                                      </td>
                                      <td>
                                        <span
                                          :class="
                                            'badge bg-soft text-capitalize ' +
                                            (org.employment_status === 'active'
                                              ? 'bg-success  text-white'
                                              : 'bg-danger text-white')
                                          "
                                          >{{ org.employment_status }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="fas fa-files"></i
                        ></span>
                        <span class="badge rounded-pill bg-success float-end">{{
                          files.length
                        }}</span>
                        <span class="d-none d-sm-block">Files</span>
                      </template>
                      <b-card-text>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="drag-area">
                              <div>
                                <div
                                  :class="[
                                    'dropZone',
                                    dragging ? 'dropZone-over' : '',
                                  ]"
                                  @dragenter="dragging = true"
                                  @dragleave="dragging = false"
                                >
                                  <div class="dropZone-info" @drag="onChange">
                                    <span
                                      style="
                                        font-size: 21pt;
                                        margin-bottom: 15px;
                                        color: #bebebe;
                                      "
                                      class="
                                        fas
                                        fa-cloud-upload-alt
                                        dropZone-title
                                      "
                                    ></span>
                                    <span class="dropZone-title"
                                      >Drag and drop files here</span
                                    >
                                    <span> Or </span>
                                    <button
                                      type="button"
                                      class="
                                        btn btn-primary btn-sm btn-task
                                        mb-3
                                        mt-3
                                        removeFile
                                      "
                                      @click="fileInput.click()"
                                    >
                                      Browse files
                                    </button>
                                    <div class="dropZone-upload-limit-info">
                                      <div>extension support: *</div>
                                      <div>maximum file size: 5 MB</div>
                                    </div>
                                  </div>
                                  <input
                                    refs="fileInput"
                                    type="file"
                                    @change="onChange"
                                    multiple
                                  />
                                </div>
                              </div>
                            </div>

                            <template v-if="fileBeforeUpload">
                              <p></p>
                              <div
                                v-for="(fileData, index) in fileBeforeUpload"
                                :key="index"
                                class="file-list-item"
                              >
                                <a :href="fileData.file" target="_blank">
                                  {{ fileData.name }}
                                </a>
                                <button
                                  class="
                                    btn btn-link
                                    text-danger text-gradient
                                    px-3
                                    mb-0
                                  "
                                  :disabled="loadingAction"
                                  type="button"
                                  @click="deleteFileBeforeUpload(fileData)"
                                >
                                  <i
                                    class="far fa-trash-alt me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Delete
                                </button>
                              </div>
                            </template>
                          </div>
                        </div>

                        <template v-if="files">
                          <div
                            v-for="(fileData, index) in files"
                            :key="index"
                            class="file-list-item"
                          >
                            <a :href="fileData.file" target="_blank">
                              {{ fileData.filename }}
                            </a>

                            <button
                              class="
                                btn btn-link
                                text-danger text-gradient
                                px-3
                                mb-0
                              "
                              :disabled="loadingAction"
                              type="button"
                              @click="deleteFile(fileData)"
                            >
                              <i
                                class="far fa-trash-alt me-2"
                                aria-hidden="true"
                              ></i
                              >Delete
                            </button>
                          </div>
                        </template>

                        <p></p>
                        <div class="row">
                          <div class="col-12">
                            <button
                              :disabled="
                                !fileBeforeUpload ||
                                fileBeforeUpload.length === 0 ||
                                loadingAction
                              "
                              type="button"
                              class="btn btn-primary waves-effect waves-light"
                              @click="onUploadFileToContact()"
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                        <div v-if="files.length === 0" class="text-center">
                          There are no file(s)
                        </div>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contactsService } from '../services/contacts.service'
import moment from 'moment'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import { VueEditor } from 'vue2-editor'
import { utilService } from '../services/util.service'
import { activitiyService } from '../services/activities.service'
import { authenticationService } from '../services/authentication.service'
import { required, url } from 'vuelidate/lib/validators'
// import VuePdfEmbed from 'vue-pdf-embed';

export default {
  name: 'ContactDetail',
  components: {
    VueEditor,
    FullCalendar
    // VuePdfEmbed
  },
  data () {
    return {
      detail: null,
      loading: true,
      loadingAction: false,
      tabIndex: 0,
      filterStatus: 'active',
      files: [],
      fileBeforeUpload: [],
      dragging: false,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, listPlugin],
        initialView: 'listWeek',
        events: [],
        height: 452,
        eventClick: this.showEvent
      },
      userInfor: {},
      events: [],
      loadingCalendar: true,
      contactContentTypeId: 33,
      noteContent: '',
      listNotes: null,
      linkedin_url: '',
      submitted: false,
      fetchingProfile: false,
      crystalProfile: null,
      isNotReady: false,
      crystalFile: null
    }
  },
  validations: {
    linkedin_url: { url, required }
  },
  computed: {
    filteredOrg () {
      return this.detail.organizations_contacts.filter((x) => {
        return x.employment_status === this.filterStatus
      })
    }
  },
  watch: {
    filterStatus () {
      // this.detail.organizations_contacts.sort((x, y) => {
      //   return x.employment_status === this.filterStatus ? -1 : y.employment_status === this.filterStatus ? 1 : 0
      // })
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      this.$router.push('/mpg/contacts')
    }

    if (this.$route.params.type === 'details') {
      this.tabIndex = 0
    } else if (this.$route.params.type === 'files') {
      this.tabIndex = 2
    } else {
      this.tabIndex = 1
    }

    this.userInfor = utilService.userInforValue

    activitiyService.getData().then((rs) => {
      rs.forEach((event) => {
        const evt = {
          title: event.title,
          data: event,
          date: event.start,
          id: event.id
        }
        this.events.push(evt)
      })
      this.$nextTick(() => {
        this.loadingCalendar = false
        if (this.$refs.fullCalendar) {
          this.$refs.fullCalendar.getApi().addEventSource(this.events)
        }
      })
    })

    if (this.$route.params.type === 'details') {
      this.tabIndex = 0
    } else {
      this.tabIndex = 1
    }
    const type = authenticationService.currentContentTypeValue
    contactsService
      .getFileFile('contact-' + this.$route.params.id)
      .then((files) => {
        this.files = files.results
      })
    const contentType = type.find((e) => e.model === 'contact').id
    this.fetchingProfile = true
    contactsService
      .getFileFileByContentAndObject(contentType, this.$route.params.id)
      .then((files) => {
        if (files.results.length > 0) {
          this.crystalFile = files.results[0]
        }
        this.fetchingProfile = false
      })
    contactsService.getDataById(this.$route.params.id).then((rs) => {
      this.detail = rs
      // const regex = /[a-z-]+(?=[#a-z?=]+$|$)/
      if (this.detail.linkedin_url && this.detail.linkedin_url !== '') {
        // const url = this.detail.linkedin_url.slice(
        //   0,
        //   this.detail.linkedin_url.lastIndexOf('/')
        // )
        // const slug = regex.exec(url)
        // this.fetchingProfile = true
        // contactsService
        //   .fetchLinkedIn(slug[0], this.$route.params.id)
        //   .then((rs) => {
        //     this.fetchingProfile = false
        //   })
        //   .catch(() => {
        //     this.fetchingProfile = false
        //     this.isNotReady = true
        //   })
      }
      utilService
        .getNoteByUser(rs.contact_id, this.contactContentTypeId)
        .then((notes) => {
          this.listNotes = notes.results
        })
      this.loading = false
    })
  },
  methods: {
    moment,
    deleteContact (id) {
      this.loadingAction = true
      contactsService.deleteDataById(id).then((rs) => {
        this.loadingAction = false
        this.$router.push('/mpg/contacts')
      })
    },
    onAddNote () {
      if (this.noteContent === '') {
        return
      }
      this.loadingAction = true
      utilService
        .addNoteToContact({
          object_id: this.detail.contact_id,
          description: this.noteContent,
          content_type: this.contactContentTypeId,
          created_by: this.userInfor.id
        })
        .then((note) => {
          this.listNotes.push(note)
          this.loadingAction = false
        })
    },
    deleteNote (id) {
      this.loadingAction = true
      utilService.deleteNote(id).then((note) => {
        this.$bvModal.hide('delete_node_modal' + id)
        this.listNotes = this.listNotes.filter((n) => n.id !== id)
        this.loadingAction = false
      })
    },
    editNote (note) {
      this.loadingAction = true
      utilService
        .updateNote(
          {
            object_id: this.detail.contact_id,
            description: note.description,
            content_type: this.contactContentTypeId
          },
          note.id
        )
        .then((note) => {
          this.$bvModal.hide('delete_edit_modal' + note.id)
          this.listNotes = this.listNotes.map((n) => {
            if (n.id === note.id) {
              n = note
            }
            return n
          })
          this.loadingAction = false
        })
    },
    showEvent (calendar) {},
    onSubmit () {},
    deleteFile (file) {
      this.loadingAction = true
      contactsService
        .deleteFile(file.file_id)
        .then((rs) => {
          this.loadingAction = false
          this.$bvToast.toast('Delete successfully.', {
            title: `Update`,
            variant: 'primary',
            solid: true
          })
          this.files = this.files.filter((e) => e.file_id !== file.file_id)
          this.loadingAction = false
        })
        .catch(() => {
          this.$bvToast.toast('Cannot delete this file.', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
        })
    },

    onChange (e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.dragging = false
        return
      }

      this.createFile(files)
    },

    createFile (files) {
      // if (!file.type.match('text.*')) {
      //   alert('please select txt file');
      //   this.dragging = false;
      //   return;
      // }

      const inValidFile = []

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 5000000) {
          inValidFile.push(files[i])
        }
      }

      if (inValidFile.length > 0) {
        this.$bvToast.toast('Error.', {
          title: `Please check file size no over 5 MB.`,
          variant: 'danger',
          solid: true
        })
        this.dragging = false
        return
      }

      this.fileBeforeUpload = [...this.fileBeforeUpload, ...files]
      this.dragging = false
    },

    deleteFileBeforeUpload (fileData) {
      this.fileBeforeUpload = this.fileBeforeUpload.filter(
        (e) => e.name !== fileData.name
      )
    },

    onUploadFileToContact () {
      if (this.fileBeforeUpload.length > 0) {
        const type = authenticationService.currentContentTypeValue
        const contentType = type.find((e) => e.model === 'contact').id
        this.loadingAction = true
        const promise = []
        for (let i = 0; i < this.fileBeforeUpload.length; i++) {
          let formData = new FormData()
          formData.append('file', this.fileBeforeUpload[i])
          formData.append('filename', this.fileBeforeUpload[i].name)
          formData.append('object_id', 'contact-' + this.$route.params.id)
          formData.append('content_type', contentType)
          promise.push(
            contactsService.uploadFile(formData).then(
              (rs) => {
                return rs
              },
              (error) => {
                this.$bvToast.toast('Error.', {
                  title: `Error. Cannot Upload File ${error}`,
                  variant: 'danger',
                  solid: true
                })
              }
            )
          )
        }
        Promise.all(promise).then((values) => {
          this.$nextTick(() => {
            setTimeout(() => {
              const type = authenticationService.currentContentTypeValue
              const contentType = type.find((e) => e.model === 'contact').id
              contactsService
                .getFileFileByContentAndObject(
                  contentType,
                  'contact-' + this.$route.params.id
                )
                .then((files) => {
                  this.files = files.results
                  this.loadingAction = false
                  this.fileBeforeUpload = []
                })
            }, 100)
          })
        })
      } else {
        this.loadingAction = false
      }
    },
    onChangeTab (tab) {
      switch (tab) {
        case 0:
          this.$router.push(`/mpg/contacts/${this.$route.params.id}/details`)
          break
        case 1:
          this.$router.push(
            `/mpg/contacts/${this.$route.params.id}/organizations`
          )
          break
        case 2:
          this.$router.push(`/mpg/contacts/${this.$route.params.id}/files`)
          break
        default:
          break
      }
    },
    onShowProfile () {
      this.$refs.mysidebar.show()
    },
    onSubmitLinkedin () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      const regex = /[a-z-]+(?=[#a-z?=]+$|$)/
      const url = this.linkedin_url.slice(
        0,
        this.linkedin_url.lastIndexOf('/')
      )
      const slug = regex.exec(url)
      if (slug) {
        this.detail.linkedin_url = this.linkedin_url
        contactsService.update(this.detail, this.$route.params.id)
        this.fetchingProfile = true
        this.isNotReady = false
        contactsService
          .fetchLinkedIn(slug[0], this.$route.params.id)
          .then((rs) => {
            this.fetchingProfile = false
            this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
          })
          .catch(() => {
            this.fetchingProfile = false
            this.isNotReady = true
          })
      } else {
        this.$bvToast.toast('Error.', {
          title: `Cannot get slug from your url. Please enter valid linkedin url. Example: https://www.linkedin.com/in/your_username`,
          variant: 'danger',
          solid: true
        })
      }
    },
    fetchProfile () {
      const regex = /[a-z-]+(?=[#a-z?=]+$|$)/
      const url = this.detail.linkedin_url.slice(
        0,
        this.detail.linkedin_url.lastIndexOf('/')
      )
      const slug = regex.exec(url)
      this.fetchingProfile = true
      contactsService
        .fetchLinkedIn(slug[0], this.$route.params.id)
        .then((rs) => {
          this.fetchingProfile = false
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
        })
        .catch(() => {
          this.fetchingProfile = false
          this.isNotReady = true
        })
    },
    downloadURI (uri, name) {
      const link = document.createElement('a')
      link.download = name
      link.href = uri
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.loading-indicator {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  height: calc(100% - 100px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eeeeee3d;
}
.table.ctrl-h > :not(caption) > * > * {
  padding: 1.058rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/ContactDetail.vue